import SettingsDev from "./../settings/AlexaLoginDev.json";
import SettingsProd from "./../settings/AlexaLogin.json";
import SettingsGetProfile from "settings/AlexaGetProfile.json";
import NodeJSAPISettingsProd from "settings/AlexaNodeJSAPI.json";
import NodeJSAPISettingsDev from "settings/AlexaNodeJSAPIDev.json";
import AlexaWebService from "settings/AlexaWebService.json";
import AlexaSkillEnablement from "settings/AlexaSkillEnablement.json";
const allSettled = require("promise.allsettled");
var any = require("promise.any");
allSettled.shim();
any.shim();
const keycode = require("keycode");
const NodeJSAPISettings = getNodeJSAPISettings();

function getNodeJSAPISettings() {
  return process.env.NODE_ENV === "development"
    ? NodeJSAPISettingsDev
    : NodeJSAPISettingsProd;
}

const httpMessageParser = require("http-message-parser");
export class AlexaCommon {
  _alexaJson = "";

  static get settings() {
    return process.env.NODE_ENV === "development" ? SettingsDev : SettingsProd;
  }

  static get getProfileSettings() {
    // Only use property is RESPONSE_TYPE
    return SettingsGetProfile;
  }

  /**
   * @see
   * https://developer.amazon.com/docs/login-with-amazon/implicit-grant.html
   */
  static buildGetProfileUrl(authObj) {
    let authUrl =
      `https://www.amazon.com/ap/oa?` +
      `client_id=${window.clientId}` +
      `&scope=${encodeURIComponent(process.env.REACT_APP_ALEXA_LOGIN_SCOPE)}` +
      `&response_type=${authObj.RESPONSE_TYPE}` +
      `&redirect_uri=${encodeURI(
        process.env.REACT_APP_ALEXA_LOGIN_REDIRECT_URI
      )}` +
      `&state=208257577110975193121591895857093449424`;

    return authUrl;
  }

  /**
   *
   * @param {*} authObj
   * @test
   */
  static buildAuthCodeUrl(authObj) {
    authObj.SCOPE_DATA["alexa:all"]["productID"] =
      process.env.REACT_APP_ALEXA_LOGIN_CLIENT_PRODUCTID;
    authObj.SCOPE_DATA["alexa:all"]["productInstanceAttributes"][
      "deviceSerialNumber"
    ] = process.env.REACT_APP_ALEXA_LOGIN_CLIENT_DEVICE_SERIAL_NUMBER;
    let authUrl =
      `https://www.amazon.com/ap/oa?` +
      `client_id=${window.clientId}` +
      `&scope=${encodeURIComponent(process.env.REACT_APP_ALEXA_LOGIN_SCOPE)}` +
      `&scope_data=${encodeURIComponent(JSON.stringify(authObj.SCOPE_DATA))}` +
      `&response_type=${authObj.RESPONSE_TYPE_CODE}` +
      `&redirect_uri=${encodeURI(
        process.env.REACT_APP_ALEXA_LOGIN_REDIRECT_URI
      )}`;

    return authUrl;
  }
  /**
   * @return
   * the full url string of HTTP get
   * @see https://razersw.atlassian.net/wiki/spaces/RCFE/pages/498172030/Razer+Alexa+OAuth2+API
   */
  static buildRazerOuthCodeUrl() {
    let authUrl =
      `${process.env.REACT_APP_ALEXA_RAZER_SERVER_ENDPOINT}` +
      `${process.env.REACT_APP_ALEXA_RAZER_SERVER_GETCODE}`;
    return authUrl;
  }

  static buildRazerOuthCheckAmaonRazerIdUrl() {
    let authUrl =
      `${process.env.REACT_APP_ALEXA_RAZER_SERVER_ENDPOINT}` +
      `${process.env.REACT_APP_ALEXA_RAZER_SERVER_CHECKAMAZONRAZERID}`;
    return authUrl;
  }

  static buildRazerOuthAccountLinksUrl() {
    let authUrl = `${process.env.REACT_APP_ALEXA_RAZER_SERVER_ENDPOINT}${process.env.REACT_APP_ALEXA_RAZER_SERVER_ACCOUNTLINKS}`;
    return authUrl;
  }

  static buildAlexaAccountLinkingURL() {
    let accountLinkingRerieveURL = AlexaSkillEnablement.AccountLinkingV0;
    if (!accountLinkingRerieveURL) return;
    accountLinkingRerieveURL = accountLinkingRerieveURL.replace(
      AlexaSkillEnablement.ReplaceSkillIdRegex,
      process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_SkillId
    );
    let authUrl =
      `${process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_ENDPOINT}` +
      `${accountLinkingRerieveURL}`;
    return authUrl;
  }

  /**
   * @return authUrl
   * @see https://developer.amazon.com/docs/smapi/smapi-overview.html
   */
  static buildAlexaSkillEnableURL() {
    let enableStatusURL = AlexaSkillEnablement.EnableStatus;
    if (!enableStatusURL) {
      return;
    }
    enableStatusURL.replace(
      AlexaSkillEnablement.ReplaceSkillIdRegex,
      process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_SkillId
    );
    enableStatusURL.replace(
      AlexaSkillEnablement.ReplaceStageRegex,
      process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_STAGE
        ? process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_STAGE
        : AlexaSkillEnablement.Stage
    );

    let authUrl =
      `${process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_ENDPOINT}` +
      `${enableStatusURL}`;
    return authUrl;
  }

  /**
   *
   * @param {*} method
   * @param {*} body
   */
  static buildAlexaSkillNodeJSCallBodyObject(method, body = "") {
    let endpointURL = process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_ENDPOINT;
    let hostname = endpointURL.replace("https://", "");
    let alexaSkillPath = AlexaSkillEnablement.skillEnablementStatus;
    if (!alexaSkillPath) {
      return;
    }
    let tempPath = alexaSkillPath.replace(
      AlexaSkillEnablement.ReplaceSkillIdRegex,
      process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_SkillId
    );
    let path = tempPath.replace(
      AlexaSkillEnablement.ReplaceStageRegex,
      AlexaSkillEnablement.Stage
    );
    let bodyMethod = method;
    let bodyBody = body;
    return {
      hostname: hostname,
      path: path,
      method: bodyMethod,
      body: bodyBody,
    };
  }

  static buildAlexaAccountLinkingGetEndpointNodeJSCallBodyObject(endpointURL) {
    let hostname = endpointURL.replace("https://", "");
    let path = AlexaSkillEnablement.AccountLiningEndpointV1;
    return {
      hostname: hostname,
      path: path,
      method: "GET",
      body: "",
    };
  }

  static buildAlexaAccountLinkingNodeJSCallBodyObject(
    endpointURL,
    method,
    body = ""
  ) {
    let hostname = endpointURL.replace("https://", "");
    let alexaAccountLinkingPath = AlexaSkillEnablement.AccountLinkingV0;
    if (!alexaAccountLinkingPath) {
      return;
    }
    let path = alexaAccountLinkingPath.replace(
      AlexaSkillEnablement.ReplaceSkillIdRegex,
      process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_SkillId
    );
    let bodyMethod = method;
    let bodyBody = body;
    return {
      hostname: hostname,
      path: path,
      method: bodyMethod,
      body: bodyBody,
    };
  }

  static buildGeneralPostHeader() {
    let header = {
      "Content-Type": "application/json",
      "cache-control": "no-cache",
    };
    return header;
  }
  static buildCBLPostHeader() {
    let header = {
      "Content-Type": "application/x-www-form-urlencoded",
      "cache-control": "no-cache",
    };
    return header;
  }
  static buildProfileGetHeader() {
    let header = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    };
    return header;
  }
  /**
   *
   * @param {string} token
   * eyJhbGciOiJF...
   */
  static buildHeaderByBearerToken(token) {
    let header = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    };
    return header;
  }

  static buildCodeToTokenPostBody(authObj, code) {
    let postBody = {
      grant_type:
        typeof authObj !== "undefined" ? authObj.CODE_TO_TOKEN_GRANT_TYPE : "",
      code: code,
      client_id: window.clientId,
      client_secret: window.clientSecret,
      redirect_uri: encodeURI(process.env.REACT_APP_ALEXA_LOGIN_REDIRECT_URI),
    };
    return postBody;
  }

  static buildCBLPostBody(authObj) {
    let postBody = {
      response_type: authObj.RESPONSE_TYPE_DEVICE_CODE,
      client_id: window.clientId,
      scope: `alexa:all profile`,
      scope_data: authObj.SCOPE_DATA,
    };
    return postBody;
  }

  static buildDeviceTokenPostBody(authObj, deviceCode, userCode) {
    let postBody = {
      grant_type: authObj.RESPONSE_TYPE_DEVICE_CODE,
      device_code: deviceCode,
      user_code: userCode,
    };
    return postBody;
  }

  static buildRefreshTokenToTokenPostBody(authObj, refreshToken) {
    let postBody = {
      grant_type:
        typeof authObj !== "undefined" ? authObj.RESPONSE_TYPE_REFRESH : "",
      refresh_token: refreshToken,
      client_id: window.clientId,
      client_secret: window.clientSecret,
    };
    return postBody;
  }

  static buildRegisterAmazonRazerIdAccountLinkingPostBody(
    amazonUserId,
    unlinkCurrAmazonIdFromAny,
    unlinkCurrRazerIdFromAny
  ) {
    let postBody = {};
    postBody = {
      amazon_user_id: amazonUserId,
      unlink_amazon_user_id_from_others: unlinkCurrAmazonIdFromAny,
      unlink_from_other_amazon_user_ids: unlinkCurrRazerIdFromAny,
    };
    return postBody;
  }

  /**
   * @param {object} localeObj
   * @example
   * localeObj.active
   * localeObj.supported
   * @param {string} accessToken
   * @example
   * ABCDEF123
   */
  static buildSetLocalePostBody(localeObj, accessToken) {
    let postBody = {};
    if (typeof localeObj !== "undefined") {
      postBody = {
        access_token: accessToken,
        locale: localeObj.active,
      };
    }
    return postBody;
  }
  static buildSetDNDStatusPostBody(dndStatusObj, accessToken) {
    let postBody = {};
    if (
      dndStatusObj &&
      typeof dndStatusObj === "object" &&
      dndStatusObj.constructor === Object
    ) {
      postBody = {
        access_token: accessToken,
        is_on: dndStatusObj.enable,
      };
    }
    return postBody;
  }

  static buildAleaxSkillRequestPostBody(alexaSkillObj, accessToken) {
    let postBody = {};
    if (
      alexaSkillObj &&
      typeof alexaSkillObj === "object" &&
      alexaSkillObj.constructor === Object
    ) {
      postBody = {
        access_token: accessToken,
        hostname: alexaSkillObj.hostname,
        path: alexaSkillObj.path,
        method: alexaSkillObj.method,
        body: alexaSkillObj.body,
      };
    }
    return postBody;
  }

  /**
   * 
   * @param {string} codeFromRazerServer
   * @see https://razersw.atlassian.net/wiki/spaces/RCFE/pages/498172030/Razer+Alexa+OAuth2+API
   * @description get localStorage.getItem("razerCode"); 
   * @example
   * {  
   *  "skill":{
   *          "id":"amzn1.ask.skill.47c9d48c-f128-4fa4-846a-df3287ef53b9",
   *          "stage":"development"
   *    },
   *    "accountLinkRequest":{  
   *          "authCode":[codeFromRazerServer]
   *    }
   }
   */
  static buildSetAccountLinkingPostBody(codeFromRazerServer) {
    let postBody = {
      skill: {
        id: process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_SkillId,
        stage: process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_STAGE,
      },
      accountLinkRequest: {
        authCode: codeFromRazerServer,
        type: "AUTH_CODE",
        redirectUri: process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_REDIRECT_URI,
      },
    };
    return postBody;
  }

  static buildBearerTokenString(token) {
    return `Bearer ${token}`;
  }

  static restfulGetCall(url, headers, isCors = true, params = {}) {
    let corsMode = isCors ? "cors" : "no-cors";
    console.log(`restfulPostCall start ${url}`);
    return new Promise((resolve, reject) => {
      try {
        // var currUrl = new URL(url);
        // currUrl.search = new URLSearchParams(params);
        var currUrl = AlexaCommon.urlWithParamBuilder(url, params);
        fetch(currUrl, {
          method: "get",
          mode: corsMode,
          headers: headers,
        })
          .then((response) => {
            console.log(
              "restfulGetCall url is " +
                url +
                " response code: " +
                response.status
            );
            if (
              response.status !== 200 &&
              response.status !== 204 &&
              response.status !== 201
            ) {
              throw response.statusText;
            }
            response.text().then((val) => {
              let res;
              try {
                res = JSON.parse(val);
              } finally {
                return resolve(res);
              }
            });
          })
          .catch((err) => {
            AlexaCommon.consoleLogDataUIFatalError(
              "restfulGetCall error",
              JSON.stringify(err)
            );
            return reject(err);
          });
      } catch (e) {
        AlexaCommon.consoleLogDataUIFatalError(
          "restfulGetCall error",
          JSON.stringify(e)
        );
        return reject(e);
      }
    });
  }

  static restfulPostCall(url, headers, body, isCors = true) {
    let corsMode = isCors ? "cors" : "no-cors";
    console.log(`restfulPostCall start ${url} : ${JSON.stringify(body)}`);
    return new Promise((resolve, reject) => {
      try {
        fetch(url, {
          method: "post",
          mode: corsMode,
          headers: headers,
          body: JSON.stringify(body),
        })
          .then((response) => {
            console.log("!@#$" + JSON.stringify(response));
            if (!response.ok) {
              var notSuccessfulObj = {
                status: response.status,
              };
              response
                .text()
                .then((val) => {
                  console.log(JSON.stringify(val));
                  notSuccessfulObj.message = val;
                  return reject(notSuccessfulObj);
                })
                .catch(() => {
                  return reject();
                });
            } else {
              response
                .text()
                .then((val) => {
                  let res;
                  try {
                    res = JSON.parse(val);
                  } finally {
                    console.log("!@#$" + JSON.stringify(response));
                    return resolve(res);
                  }
                })
                .catch(() => {
                  return reject();
                });
            }
          })
          .catch((err) => {
            AlexaCommon.consoleLogDataUIFatalError(
              "restfulPostCall error",
              JSON.stringify(err)
            );
            return reject(err);
          });
      } catch (e) {
        AlexaCommon.consoleLogDataUIFatalError(
          "restfulPostCall error",
          JSON.stringify(e)
        );
        return reject(e);
      }
    });
  }

  static restfulPutCall(url, headers, body, isCors = true) {
    let corsMode = isCors ? "cors" : "no-cors";
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "put",
        mode: corsMode,
        headers: headers,
        body: JSON.stringify(body),
      }).then(function (response) {
        if (
          response.status !== 200 &&
          response.status !== 204 &&
          response.status !== 201
        ) {
          var notSuccessfulObj = {
            status: response.status,
          };
          response
            .text()
            .then((val) => {
              notSuccessfulObj.message = val;
              return reject(notSuccessfulObj);
            })
            .finally(() => {
              return reject();
            });
        } else {
          response
            .text()
            .then((val) => {
              let res;
              try {
                res = JSON.parse(val);
              } finally {
                return resolve(res);
              }
            })
            .catch(() => {
              return reject();
            })
            .finally(() => {
              return reject();
            });
        }
      });
    });
  }

  static restfulDeleteCall(url, headers, body = {}, isCors = true) {
    let corsMode = isCors ? "cors" : "no-cors";
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "delete",
        mode: corsMode,
        headers: headers,
        body: JSON.stringify(body),
      }).then(function (response) {
        if (
          response.status !== 200 &&
          response.status !== 204 &&
          response.status !== 201
        ) {
          var notSuccessfulObj = {
            status: response.status,
          };
          response
            .text()
            .then((val) => {
              notSuccessfulObj.message = val;
              return reject(notSuccessfulObj);
            })
            .finally(() => {
              return reject();
            });
        } else {
          response
            .text()
            .then((val) => {
              let res;
              try {
                res = JSON.parse(val);
              } finally {
                return resolve(res);
              }
            })
            .catch(() => {
              return reject();
            })
            .finally(() => {
              return reject();
            });
        }
      });
    });
  }

  /** 
  * @param payload
  * @return options
  * @example 
      options.token;
      options.mainTitle;
      options.textField;
      options.subTitle; 
  */
  static payloadToCardOption(payload) {
    let cardOption = {};
    if (!payload) {
      return cardOption;
    }
    cardOption.token = payload.token;
    cardOption.type = payload.type;
    if (payload.title) {
      cardOption.mainTitle =
        typeof payload.title !== "undefined" ? payload.title.mainTitle : "";
      cardOption.subTitle =
        typeof payload.title !== "undefined" ? payload.title.subTitle : "";
    }
    if (payload.image && typeof payload.image !== "undefined") {
      cardOption.image = payload.image;
    }

    cardOption.textField = payload.textField;
    return cardOption;
  }

  /**
   *
   * @param {string} code
   * @returns resolve
   * {
   *     access_token: String,
   *     expires_in: Number,
   *     refresh_token: String
   *     token_type: String
   *  }
   */
  static getTokenFromCode(code) {
    let header = AlexaCommon.buildGeneralPostHeader();
    let postBody = AlexaCommon.buildCodeToTokenPostBody(
      AlexaCommon.settings,
      code
    );
    return AlexaCommon.restfulPostCall(
      process.env.REACT_APP_ALEXA_LOGIN_CODE_TO_TOKEN_ENDPOINT,
      header,
      postBody
    );
  }

  static getTokenFromRefreshToken(refreshToken) {
    let header = AlexaCommon.buildGeneralPostHeader();
    let postBody = AlexaCommon.buildRefreshTokenToTokenPostBody(
      AlexaCommon.settings,
      refreshToken
    );
    return AlexaCommon.restfulPostCall(
      process.env.REACT_APP_ALEXA_LOGIN_CODE_TO_TOKEN_ENDPOINT,
      header,
      postBody
    );
  }

  static getCBLCodeToDisplay() {
    let header = AlexaCommon.buildGeneralPostHeader();
    let postBody = AlexaCommon.buildCBLPostBody(AlexaCommon.settings);
    return AlexaCommon.restfulPostCall(
      AlexaCommon.settings.REACT_APP_ALEXA_CBL_ENDPOINT,
      header,
      postBody
    );
  }

  static getDeviceToken(userCode, deviceCode) {
    let header = AlexaCommon.buildGeneralPostHeader();
    let postBody = AlexaCommon.buildDeviceTokenPostBody(
      AlexaCommon.settings,
      deviceCode,
      userCode
    );
    return AlexaCommon.restfulPostCall(
      process.env.REACT_APP_ALEXA_LOGIN_CODE_TO_TOKEN_ENDPOINT,
      header,
      postBody
    );
  }

  static getAmazonUserName() {
    return AlexaCommon.restfulGetCall(
      process.env.REACT_APP_ALEXA_LOGIN_URL_TO_GET_USER_PROFILE_INFO,
      AlexaCommon.buildProfileGetHeader()
    );
  }

  /**
   * @example 
     "Language": "{\"active\":\"en-US\",\"supported\":[\"de-DE\",\"en-AU\",\"en-CA\",\"en-GB\",\"en-IN\",\"en-US\",\"es-ES\",\"es-MX\",\"fr-CA\",\"fr-FR\",\"ja-JP\"]}",
     "DisplayCardLayout": "{\"active\":\"landscape\",\"supported\":[\"landscape\",\"portrait\"]}",
     "DoNotDisturb": "{\"enable\":false,\"schedule\":false}",
     "AudioDevice": "{\"active\":\"default\",\"supported\":[\"default\",\"Headset Microphone (Razer Kraken 7.1 V2)\",\"Headset Microphone (2- Razer ManO'War)\"]}",
     "HotKey": "{"hotkey":"2|65"}"
   */
  static getalexa() {
    return this._alexaJson;
  }

  /**
   *
   * @param {string} data
   */
  static setalexaJson(data) {
    console.log("alexa json from wpf:" + data);
    this._alexaJson = data;
  }

  static getHotKeyTriggerFromKeyCode(data) {
    let finalShortCut = "";
    let values = data.split("|");
    switch (values[0]) {
      case "1":
        finalShortCut += "Alt + ";
        break;
      case "2":
        finalShortCut += "Ctrl + ";
        break;
      case "3":
        finalShortCut += "Ctrl + Alt + ";
        break;
      case "4":
        finalShortCut += "Shift + ";
        break;
      case "5":
        finalShortCut += "Shift + Alt + ";
        break;
      case "6":
        finalShortCut += "Ctrl + Shift + ";
        break;
      case "7":
        finalShortCut += "Ctrl + Shift + Alt + ";
        break;
    }
    let keyName = keycode(parseInt(values[1]));
    if (typeof keyName !== "undefined") finalShortCut += keyName.toUpperCase();
    return finalShortCut;
  }

  /**
   *
   * @param {string} synpaseStr
   * @example "{"Language": "{\"active\":\"en-US\",\"supported\":[\"de-DE\",\"en-AU\",\"en-CA\",\"en-GB\",\"en-IN\",\"en-US\",\"es-ES\",\"es-MX\",\"fr-CA\",\"fr-FR\",\"ja-JP\"]}","DisplayCardLayout": "{\"active\":\"landscape\",\"supported\":[\"landscape\",\"portrait\"]}","DoNotDisturb": "{\"enable\":true,\"schedule\":false}","AudioDevice": "{\"active\":\"default\",\"supported\":[\"default\",\"Headset Microphone (2- Razer Kraken 7.1 V2)\",\"Headset Microphone (Razer Kraken 7.1 V2)\"]}","HotKey": "{\"hotkey\":\"6|83\"}"}"
   * @description you can get example from http://localhost:5426/api/Alexa/get with a bearer Token.
   *              To get the bearer token, add a breakpoint AlexaClient.cs in Synapase 3 common code.
   * @returns {object} jsonObj for synapseStr
   */
  static parseSynapseStringToJsonObj(synpaseStr) {
    var res = {};
    if (typeof synpaseStr !== "undefined") {
      try {
        let objButValueIsStr = JSON.parse(synpaseStr);
        for (var key in objButValueIsStr) {
          res[key] = JSON.parse(objButValueIsStr[key]);
        }
      } catch {
        console.error(`parsing synapse string failed: ${synpaseStr}`);
      }
    }
    return res;
  }

  /**
   *
   * @param {object} jsonObj
   */
  static makeSynapseStringValueOnlyFromJsonObj(jsonObj) {
    var synapseStr = "";
    if (AlexaCommon.isPlainObject(jsonObj)) {
      try {
        synapseStr = JSON.stringify(jsonObj);
      } catch {
        console.error(`creating synapse string(value Only) failed: ${jsonObj}`);
      }
    }
    return synapseStr;
  }

  static getSynapseSettingsLanguageObj(settingsObj) {
    let languageObj;
    if (AlexaCommon.isPlainObject(settingsObj)) {
      languageObj = settingsObj["Language"];
    }
    return languageObj;
  }

  static getSynapseApplicationSettingObj(settingsObj) {
    let applicationSettingObj;
    if (AlexaCommon.isPlainObject(settingsObj)) {
      applicationSettingObj =
        settingsObj[AlexaWebService.ApplicationSetting_Feature_Key];
    }
    return applicationSettingObj;
  }
  static getSynapseApplicationSoundObj(settingsObj) {
    let applicationSoundObj;
    if (AlexaCommon.isPlainObject(settingsObj)) {
      applicationSoundObj =
        settingsObj[AlexaWebService.ApplicationSound_Feature_Key];
    }
    return applicationSoundObj;
  }
  static getSynapseDisplayCardLayoutObj(settingsObj) {
    let displayCardLayoutObj;
    if (AlexaCommon.isPlainObject(settingsObj)) {
      displayCardLayoutObj =
        settingsObj[AlexaWebService.DisplayCardLayout_Feature_Key];
    }
    return displayCardLayoutObj;
  }
  static getSynapseSettingsAudioDeviceObj(settingsObj) {
    let audioDeviceObj;
    if (AlexaCommon.isPlainObject(settingsObj)) {
      audioDeviceObj = settingsObj["AudioDevice"];
    }
    return audioDeviceObj;
  }

  static getSynapseRazerSkillStatus(razerSkillObj) {
    let status = false;
    if (AlexaCommon.isPlainObject(razerSkillObj)) {
      let statusObj = razerSkillObj[AlexaWebService.RazerSkill_Feature_Key];
      if (typeof statusObj !== "undefined") {
        status = statusObj[AlexaWebService.Enable_Key];
      }
    }
    return status;
  }

  /**
   *
   * @param {string} theme
   * @example
   *  dark
   *  light
   */
  static changeGlobalTheme(theme) {
    if (typeof theme === undefined) {
      return;
    }
    document.documentElement.setAttribute("data-theme", theme);
  }

  static isArrayNotNullAndNotEmpty(array) {
    return array instanceof Array && array.length > 0 ? true : false;
  }

  /**
   *
   * @ref https://stackoverflow.com/questions/8834126/how-to-efficiently-check-if-variable-is-array-or-object-in-nodejs-v8/10004250
   */
  static isObjectAndNotNull(obj) {
    return !!obj && obj.constructor === Object;
  }

  /**
   *
   * @param {object} languageData
   * @example
   * {\"active\":\"en-US\",\"supported\":[\"de-DE\",\"en-AU\",\"en-CA\",\"en-GB\",\"en-IN\",\"en-US\",\"es-ES\",\"es-MX\",\"fr-CA\",\"fr-FR\",\"ja-JP\"]}
   * @param {string} token
   * ABCDEF123
   */

  static nodeCallUpdateLocale(languageData, token) {
    return new Promise((resolve) => {
      let headers = AlexaCommon.buildGeneralPostHeader();
      let body = AlexaCommon.buildSetLocalePostBody(languageData, token);
      AlexaCommon.restfulPostCall(
        `${process.env.REACT_APP_ALEXA_NODEJS_API_ENDPOINT}${process.env.REACT_APP_ALEXA_NODEJS_API_SETAVSLOCALE}`,
        headers,
        body
      ).finally(() => {
        resolve();
      });
    });
  }

  static nodeHttpCall(alexaSkillApiData, token) {
    let headers = AlexaCommon.buildGeneralPostHeader();
    let body = AlexaCommon.buildAleaxSkillRequestPostBody(
      alexaSkillApiData,
      token
    );
    let url = `${process.env.REACT_APP_ALEXA_NODEJS_API_ENDPOINT}${process.env.REACT_APP_ALEXA_NODEJS_API_ALEXA_HTTP_REQUEST}`;

    return AlexaCommon.restfulPostCall(url, headers, body);
  }

  /**
   * 
   * @param {string} token
   * @returns
   * 200 
   {
      "endpoints": [
          "api.amazonalexa.com"
      ]
   }
   *  
   */
  static async getAccountLinkingEndpointForUser() {
    let httpApiData = AlexaCommon.buildAlexaAccountLinkingGetEndpointNodeJSCallBodyObject(
      process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_ENDPOINT
    );
    let httpApiData_EU = AlexaCommon.buildAlexaAccountLinkingGetEndpointNodeJSCallBodyObject(
      process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_ENDPOINT_EU
    );
    let httpApiData_FE = AlexaCommon.buildAlexaAccountLinkingGetEndpointNodeJSCallBodyObject(
      process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_ENDPOINT_FE
    );

    const httpApiDatas = [httpApiData, httpApiData_EU, httpApiData_FE];
    for (const apiData of httpApiDatas) {
      let res = await AlexaCommon.nodeHttpCall(
        apiData,
        localStorage.getItem("token")
      ).catch((err) => {
        console.log(
          "getAccountLinkingEndpointForUser nodeHttpCall error " +
            JSON.stringify(err)
        );
      });
      if (res && res.statusCode === 200) {
        let data = JSON.parse(res.message);
        if (data["endpoints"] instanceof Array) {
          //Got the right endpoint.
          if (data["endpoints"].length === 1) {
            AlexaCommon.consoleLogDataUIImportantInfo(
              "getAccountLinkingEndpointForUser: Get the correct account linking endpoint.",
              JSON.stringify(data)
            );
            localStorage.setItem(
              "accountLinkingEndpoint",
              data["endpoints"][0]
            );
          } else {
            AlexaCommon.consoleLogDataUIImportantInfo(
              "Could not find the correct endpoint for the user (endpoints array length larger than 1)",
              JSON.stringify(data)
            );
          }
        } else {
          AlexaCommon.consoleLogDataUIImportantInfo(
            "Could not find the correct endpoint for the user (No endpoints array in response)",
            JSON.stringify(data)
          );
        }
        break;
      } else if (res && Math.floor(res.statusCode / 100) === 5) {
        let data = JSON.parse(res.message);
        AlexaCommon.consoleLogDataUIImportantInfo(
          "Could not find the correct endpoint for the user ( getAccountLinkingEndpointForUser 5xx)",
          JSON.stringify(data)
        );
        continue;
      } else if (res && res.statusCode === 403) {
        let data = JSON.parse(res.message);
        AlexaCommon.consoleLogDataUIFatalError(
          "getAccountLinkingEndpointForUser 403 (amazon token expired).",
          JSON.stringify(data)
        );
        break;
      } else {
        console.log(
          "getAccountLinkingEndpointForUser nodeHttpCall error " +
            JSON.stringify(res)
        );
      }
    }
    if (
      localStorage.getItem("accountLinkingEndpoint") != null &&
      typeof localStorage.getItem("accountLinkingEndpoint") !== "undefined"
    ) {
      return Promise.resolve(localStorage.getItem("accountLinkingEndpoint"));
    }
    return Promise.reject();
  }

  /**
   * @description Alexa skill activation API reference.pdf
   * @returns {
   *    accountLink:{
   *         status: "LINKED"
   *    },
   *    user:{
   *        id:"amzn1.ask.account.A...N4YFYA"
   *    }
   * }
   * @summary
   * Must call getAccountLinkingEndpointForUser first.
   */
  static retrieveAccountLinkingStatus(endpoint) {
    if (!endpoint) {
      return Promise.reject();
    }
    let httpApiData = AlexaCommon.buildAlexaAccountLinkingNodeJSCallBodyObject(
      endpoint,
      "GET",
      ""
    );
    return new Promise((resolve, reject) => {
      console.log(
        "retrieveAccountLinkingStatus request " + JSON.stringify(httpApiData)
      );
      AlexaCommon.nodeHttpCall(httpApiData, localStorage.getItem("token"))
        .then((res) => {
          console.log(
            "retrieveAccountLinkingStatus status code is " + res.statusCode
          );
          if (res && res.statusCode === 200) {
            let data = JSON.parse(res.message);

            if (
              data &&
              data.accountLink &&
              data.accountLink.status === "LINKED"
            ) {
              console.log(
                "retrieveAccountLinkingStatus -> LINKED" + res.message
              );
              resolve({
                result: true,
                data: data,
              });
            } else {
              console.log(
                "retrieveAccountLinkingStatus -> NOT LINKED" + res.message
              );
              resolve({
                result: false,
                data: data,
              });
            }
          } else {
            const err = "retrieveAccountLinkingStatus error" + res.message;
            console.log(err);
            reject(err);
          }
        })
        .catch((err) => {
          console.log(
            "retrieveAccountLinkingStatus nodeHttpCall error " +
              JSON.stringify(err)
          );
          reject(err);
        });
    });
  }

  /**
   * @see https://razersw.atlassian.net/wiki/spaces/RCFE/pages/505905566/Account+Link+Management+APIs
   * @description
   * case 1:
   * "linked_to_this_user": true
   * "linked_to_other_users": any
   * "razerid_linked_to_an_amazon_user":any
   * means curr amazon id relogged in by using the same Razer Id
   * @notice
   * Do case 1 quietly without letting user know.
   *
   * case 2:
   * "linked_to_this_user": false
   * "linked_to_other_users": false
   * "razerid_linked_to_an_amazon_user":false
   * means 1. curr amazon id has not linked to anyother Razer Id.
   *       2. and curr razer id has not linked to any other amazon Id.
   * POST /internal/account_links with body params
   *      amazon_user_id (from Amazon skill enablement API)
   *      unlink_amazon_user_id_from_others (constantly true)
   *      unlink_from_other_amazon_user_ids (constantly true)
   *
   * @notice
   * Do case 2 quietly without letting user know.
   *
   * case 3:
   * "linked_to_this_user": false
   * "linked_to_other_users": true/true/false
   * "razerid_linked_to_an_amazon_user": true/false/true
   * =>  linked_to_this_user === false && (linked_to_other_users === true || razerid_linked_to_an_amazon_user === true)
   *
   * Then
   * @notice
   * Do case 3 prompt a dialog and let user choose "Allow" or "Cancel"
   * If user choose "Allow" => do case 2 process.
   * If user choose "Cancel" => do logout.
   *
   * Any other cases:
   *  Server error, shouldn't happen.
   *
   * url = "https://alexa-oauth2-staging.razerapi.com/internal/account_links/check_amazon_user_id";
   */

  static checkAmazonRazerIdAccountLinking(amazonUserId, razerToken) {
    let url = AlexaCommon.buildRazerOuthCheckAmaonRazerIdUrl();
    let params = {
      amazon_user_id: amazonUserId,
    };

    let header = AlexaCommon.buildHeaderByBearerToken(razerToken);
    console.log(
      "checkAmazonRazerIdAccountLinking request" +
        url +
        " header " +
        JSON.stringify(header) +
        " params " +
        JSON.stringify(params)
    );
    return new Promise((resolve, reject) => {
      AlexaCommon.restfulGetCall(url, header, true, params)
        .then((response) => {
          if (response) {
            //case 1
            if (response["linked_to_this_user"]) {
              AlexaCommon.consoleLogDataUIImportantInfo(
                "AmazonRazerIdCombination relogin",
                JSON.stringify(response)
              );
            }
            //case 2
            else if (
              !response["linked_to_this_user"] &&
              !response["linked_to_other_users"] &&
              !response["razerid_linked_to_an_amazon_user"]
            ) {
              AlexaCommon.registerAmazonRazerIdAccountLinking(
                amazonUserId,
                false,
                false
              );
              AlexaCommon.consoleLogDataUIImportantInfo(
                "new AmazonRazerIdCombination",
                JSON.stringify(response)
              );
            }
            //case 3
            else if (
              !response["linked_to_this_user"] &&
              (response["linked_to_other_users"] ||
                response["razerid_linked_to_an_amazon_user"])
            ) {
              //Emit event to show dialog
              //window.rzevent.triggerEvent(window.rzevent.EventTypes.ACCOUNT_LINK_CONFLICTS_NOTIFICATION, amazonUserId);
              AlexaCommon.consoleLogDataUIImportantInfo(
                "linked a different account, need to unlink prev linkings",
                JSON.stringify(response)
              );
              AlexaCommon.registerAmazonRazerIdAccountLinking(
                amazonUserId,
                true,
                true
              )
                .then(() => {
                  AlexaCommon.consoleLogDataUIImportantInfo(
                    "swap AccountLinking process Success"
                  );
                })
                .catch(() => {
                  AlexaCommon.consoleLogDataUIFatalError(
                    "AmazonRazerIdAccountLinking process failed to override account linking"
                  );
                });
            }
            //case 4
            else {
              AlexaCommon.consoleLogDataUIImportantInfo(
                "Razer server API response syntax is not as expected",
                JSON.stringify(response)
              );
            }
          } else {
            AlexaCommon.consoleLogDataUIFatalError(
              "Razer server API response syntax is not as expected",
              JSON.stringify(response)
            );
          }
          resolve();
        })
        .catch((error) => {
          AlexaCommon.consoleLogDataUIFatalError(
            "check_amazon_user_id Error",
            JSON.stringify(error)
          );
          reject();
        });
    });
  }

  /**
   * @url https://alexa-oauth2-staging.razerapi.com/internal/account_links
   * @param {*} amazonUserId
   * @param {*} unlinkCurrAmazonIdFromAny
   * @param {*} unlinkCurrRazerIdFromAny
   * @description
   * Call this method when checkAmazonRazerIdAccountLinking enters case 2.
   */
  static registerAmazonRazerIdAccountLinking(
    amazonUserId,
    unlinkCurrAmazonIdFromAny,
    unlinkCurrRazerIdFromAny
  ) {
    let url = AlexaCommon.buildRazerOuthAccountLinksUrl();
    let razerToken = localStorage.getItem("synapseToken");
    let header = AlexaCommon.buildHeaderByBearerToken(razerToken);
    let body = AlexaCommon.buildRegisterAmazonRazerIdAccountLinkingPostBody(
      amazonUserId,
      unlinkCurrAmazonIdFromAny,
      unlinkCurrRazerIdFromAny
    );
    console.log(
      "registerAmazonRazerIdAccountLinking url " +
        url +
        " header " +
        JSON.stringify(header) +
        " body " +
        JSON.stringify(body)
    );
    return new Promise((resolve, reject) => {
      AlexaCommon.restfulPostCall(url, header, body, true)
        .then((response) => {
          AlexaCommon.consoleLogDataUIImportantInfo(
            "Register an account link between RazerID account Success",
            JSON.stringify(response)
          );
          //Mark amazonRazerId linked.
          let synapseToken = localStorage.getItem("synapseToken");
          localStorage.setItem("amazonUserIdCombination", amazonUserId);
          localStorage.setItem("RazerIdCombination", synapseToken);
          resolve(true);
        })
        .catch((error) => {
          try {
            if (error) {
              //check the status.
              if (error.status === 400) {
                AlexaCommon.consoleLogDataUIFatalError(
                  "400 status API resposne, need to show dialog to user",
                  JSON.stringify(error)
                );
                let amazonUserIdCombination = localStorage.getItem(
                  "amazonUserIdCombination"
                );
                let RazerIdCombination = localStorage.getItem(
                  "RazerIdCombination"
                );
                let synapseToken = localStorage.getItem("synapseToken");
                if (
                  amazonUserIdCombination === amazonUserId &&
                  RazerIdCombination === synapseToken
                ) {
                  AlexaCommon.consoleLogDataUIImportantInfo(
                    "Multiple Browser called registerAmazonRazerIdAccountLinking and got async issues, but it's ok, as long as one browser did account linking successfully."
                  );
                } else {
                  //Shouldn't be happen, if program reach here, might need to check with Cloud service team.
                  AlexaCommon.consoleLogDataUIFatalError(
                    "Shouldn't be happen.,  checkAmazonRazerIdAccountLinking API logic has some issues."
                  );
                }
              }
              //else let it been reject()
            }
          } catch {
            AlexaCommon.consoleLogDataUIFatalError(
              "Return message is not parseable Error",
              JSON.stringify(error)
            );
          }
          AlexaCommon.consoleLogDataUIFatalError(
            "Register an account link between RazerID Error",
            JSON.stringify(error)
          );
          AlexaCommon.consoleLogDataUIFatalError(
            "Register an account link between RazerID Error(detail reason)",
            JSON.stringify({
              suspectUrl: url,
              suspectHeader: header,
              suspectBody: body,
            })
          );
          reject();
        });
    });
  }

  /**
   * @description
   * Call this method when registerAmazonRazerIdAccountLinking
   * 1. GET​   /internal​/account_links
   * 2. DELETE   ​/internal​/account_links​/:id
   *
   */
  static deleteAmazonRazerIdAccountLinking(amazonUserId) {
    let url = AlexaCommon.buildRazerOuthAccountLinksUrl();
    let razerToken = localStorage.getItem("synapseToken");
    let header = AlexaCommon.buildHeaderByBearerToken(razerToken);
    //1. GET​   /internal​/account_links
    let getAmazonRazerIdForDeletePromise = new Promise((resolve, reject) => {
      console.log(amazonUserId);
      let finalUrl = url + "?amazon_user_id=" + amazonUserId;
      console.log(finalUrl);
      AlexaCommon.restfulGetCall(finalUrl, header)
        .then((response) => {
          if (response instanceof Array) {
            var foundItem = response.find((item) => {
              return item.amazon_user_id === amazonUserId;
            });
            if (foundItem) {
              resolve(foundItem.id);
            } else {
              AlexaCommon.consoleLogDataUIFatalError(
                "getAmazonRazerIdForDeletePromise NOT FOUND amazon_user_id",
                JSON.stringify(response)
              );
              reject();
            }
          } else {
            AlexaCommon.consoleLogDataUIFatalError(
              "getAmazonRazerIdForDeletePromise return format  Error",
              JSON.stringify(response)
            );
            reject();
          }
        })
        .catch((error) => {
          AlexaCommon.consoleLogDataUIFatalError(
            "getAmazonRazerIdForDeletePromise HTTP call  Error",
            JSON.stringify(error)
          );
          reject();
        });
    });
    //2. DELETE   ​/internal​/account_links​/:id
    return new Promise((resolve, reject) => {
      getAmazonRazerIdForDeletePromise
        .then((amazonRazerIdForDelete) => {
          let url = AlexaCommon.buildRazerOuthAccountLinksUrl();
          if (amazonRazerIdForDelete) {
            let finalUrl = url.concat("/", amazonRazerIdForDelete);
            AlexaCommon.restfulDeleteCall(finalUrl, header)
              .then((response) => {
                resolve();
                AlexaCommon.consoleLogDataUIImportantInfo(
                  "amazonRazerIdDeleted successfully",
                  JSON.stringify(response)
                );
              })
              .catch((error) => {
                resolve();
                AlexaCommon.consoleLogDataUIImportantInfo(
                  "amazonRazerIdDeleted failed ",
                  JSON.stringify(error)
                );
              });
          } else {
            reject();
            AlexaCommon.consoleLogDataUIFatalError(
              "amazonRazerIdForDelete is null Error",
              JSON.stringify(amazonRazerIdForDelete)
            );
          }
        })
        .catch(() => {
          reject();
        });
    });
  }

  static deleteAccountLinkingStatus(endpoint) {
    if (!endpoint) {
      return Promise.reject();
    }
    let httpApiData = AlexaCommon.buildAlexaAccountLinkingNodeJSCallBodyObject(
      endpoint,
      "DELETE",
      ""
    );
    return new Promise((resolve, reject) => {
      console.log(
        "deleteAccountLinkingStatus request " + JSON.stringify(httpApiData)
      );
      AlexaCommon.nodeHttpCall(httpApiData, localStorage.getItem("token"))
        .then((res) => {
          console.log(
            "deleteAccountLinkingStatus status code is " + res.statusCode
          );
          if (res && res.statusCode === 200) {
            resolve(true);
          } else {
            AlexaCommon.consoleLogDataUIImportantInfo(
              "Delete Account Linking error",
              res.message
            );
            reject();
          }
        })
        .catch((res) => {
          reject();
        });
    });
  }

  static setAccountLinkingStatus(codeFromRazerServer, endpoint) {
    if (!endpoint) {
      return Promise.reject();
    }
    let body = AlexaCommon.buildSetAccountLinkingPostBody(codeFromRazerServer);
    let httpApiData = AlexaCommon.buildAlexaAccountLinkingNodeJSCallBodyObject(
      endpoint,
      "POST",
      body
    );
    return new Promise((resolve, reject) => {
      console.log(
        "setAccountLinkingStatus request " + JSON.stringify(httpApiData)
      );
      AlexaCommon.nodeHttpCall(httpApiData, localStorage.getItem("token"))
        .then((res) => {
          console.log(
            "setAccountLinkingStatus status code is " + res.statusCode
          );
          let data = JSON.parse(res.message);
         
          AlexaCommon.consoleLogDataUIImportantInfo(
            "set Account Linking successfully",
            data
          );
          console.log("set Account Linking successfully" + data);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
          AlexaCommon.consoleLogDataUIImportantInfo(
            "set Account Linking error",
            JSON.stringify(error)
          );
        })
        .finally(() => {});
    });
  }

  /**
   *
   * @param {string} contentId
   * <dca5156c-46fa-4422-bd69-7fdd51952cbd_2109002723>
   * @return
   * dca5156c-46fa-4422-bd69-7fdd51952cbd_2109002723
   */
  static getOctetContentID(contentId) {
    let octetContentId = "";
    if (typeof contentId !== "string") {
      return octetContentId;
    }
    let regexPattern = /(?<=<)(.*)(?=>)/;
    let matches = contentId.match(regexPattern);
    if (matches && matches.length > 0) {
      octetContentId = matches[0];
    }
    return octetContentId;
  }
  /**
   *
   * @param {*} languageList
   * item.content
   * item.name
   * item.languageId
   */
  static sortLanguageList(languageList) {
    function compare(a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    }

    if (languageList instanceof Array) {
      languageList.sort(compare);
    }
  }

  static getLowerCase(str) {
    if (typeof str === "string" || str instanceof String) {
      return str.toLocaleLowerCase();
    }
    return undefined;
  }

  static urlWithParamBuilder(urlRoot, param) {
    let params = new URLSearchParams(param);
    let paramsStr = params.toString();
    let finalUrl =
      paramsStr === "" ? urlRoot : `${urlRoot}?${params.toString()}`;
    return finalUrl;
  }

  static isPlainObject(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
  }

  /**
   * @example
   * response.topic_id
   * response.code
   *@description
   * 1.Send topic_id to Synapse 3 wpf side.
   * 2.Store code to localStorage.
   */
  static getRazerCodeAndTopic(razerToken) {
    if (!razerToken) {
      AlexaCommon.consoleLogDataUIFatalError("razer token is null", razerToken);
    }
    let url = AlexaCommon.buildRazerOuthCodeUrl();
    let header = AlexaCommon.buildHeaderByBearerToken(razerToken);
    console.log(
      "getRazerCodeAndTopic request:" +
        url +
        " header " +
        JSON.stringify(header)
    );
    return new Promise((resolve, reject) => {
      AlexaCommon.restfulGetCall(url, header, true)
        .then((response) => {
          if (response) {
            localStorage.setItem("razerCode", response["code"]);
            AlexaCommon.consoleLogDataUIImportantInfo(
              "getRazerCodeAndTopic success",
              JSON.stringify(response)
            );
          } else {
            AlexaCommon.consoleLogDataUIFatalError(
              "Razer server API response syntax is not as expected",
              JSON.stringify(response)
            );
          }
          resolve(response["code"]);
        })
        .catch((error) => {
          AlexaCommon.consoleLogDataUIFatalError(
            "get razer code didn't success",
            error
          );
          AlexaCommon.consoleLogDataUIFatalError(
            "get razer code didn't success(detail reason)",
            JSON.stringify({
              suspectUrl: url,
              suspectHeader: header,
            })
          );
          reject();
        });
    });
  }

  /**
   * @param {message} message the output message to conosle.
   * @param {data} data the variable data to console.
   */
  static consoleLogDataToSynpase(message, data) {
    console.log(`%c ${message} : ${data}`, "color: orange;font-size:20px");
  }
  static consoleLogDataFromSynpase(message, data) {
    console.log(`%c ${message} : ${data}`, "color: blue;font-size:20px");
  }
  static consoleLogDataUIImportantInfo(message, data) {
    console.log(`%c ${message} : ${data}`, "color: purple;font-size:20px");
  }
  static consoleLogDataUIFatalError(message, data) {
    console.log(`%c ${message} : ${data}`, "color: red;font-size:20px");
  }

  static displayEnvironmentVaraible() {
    //Account Linking (Amazon's API)
    console.log(
      `SkillEnablement Endpoint: ${process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_ENDPOINT}`
    );
    console.log(
      `SkillId: ${process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_SkillId}`
    );
    console.log(
      `SkillEnablement Redirect URI: ${process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_REDIRECT_URI}`
    );
    console.log(
      `SkillEnablement Redirect URI: ${process.env.REACT_APP_ALEXA_SKILL_ENABLEMENT_REDIRECT_URI}`
    );
    //Account Linking (Razer's API)
    console.log(
      `Razer Server Endpoint: ${process.env.REACT_APP_ALEXA_RAZER_SERVER_ENDPOINT}`
    );
    //NodeJS API
    console.log(
      `NodeJS Server Endpoint: ${process.env.REACT_APP_ALEXA_NODEJS_API_ENDPOINT}`
    );
    console.log(
      `NodeJS AVS locale API route(HTTP/2): ${process.env.REACT_APP_ALEXA_NODEJS_API_SETAVSLOCALE}`
    );
    //Alexa API
    console.log(
      `Alexa Client ID: ${window.clientId}`
    );
    console.log(
      `Alexa Client Secret: ${window.clientSecret}`
    );
    console.log(
      `Alexa Login Scope: ${process.env.REACT_APP_ALEXA_LOGIN_SCOPE}`
    );
    console.log(
      `Alexa Client Product ID: ${process.env.REACT_APP_ALEXA_LOGIN_CLIENT_PRODUCTID}`
    );
    console.log(
      `Alexa Redirect URI: ${process.env.REACT_APP_ALEXA_LOGIN_REDIRECT_URI}`
    );
    //Important variables
    console.log(
      `Amazon Access Token(if has): ${localStorage.getItem("token")}`
    );
    console.log(
      `Razer Synapse Token(if has): ${localStorage.getItem("synapseToken")}`
    );
  }

  static get Pages() {
    return {
      HOME: "home",
      SKILLS: "skills",
      SETTINGS: "settings",
    };
  }
}

export async function retryOperation(operation, delay = 1000, times = 3) {
  try {
    return await operation();
  } catch (ex) {
    if (times > 1) {
      console.log(`retrying ${times}...`);
      await new Promise((resolve) => setTimeout(resolve, delay));
      return retryOperation(operation, delay, times - 1);
    } else {
      throw ex;
    }
  }
}
